<template>
  <div class="page">
    <div v-if="loading" class="card">
      <div class="icon loading"></div>
      <h2>Sonuç yükleniyor</h2>
      <p class="muted">Lütfen bekleyiniz...</p>
    </div>

    <div v-else-if="result && result.ok" class="card ok">
      <div class="icon ok">✓</div>
      <h2>Sipariş oluşturuldu</h2>
      <div class="rows">
        <div class="row">
          <span class="k">Seri/Sıra</span>
          <span class="v">{{ seriSiraText }}</span>
        </div>
        <div class="row">
          <span class="k">Başarılı satır</span>
          <span class="v">{{ satirCount }}</span>
        </div>
        <div v-if="failCount" class="row">
          <span class="k">Hatalı satır</span>
          <span class="v">{{ failCount }}</span>
        </div>
      </div>

      <div v-if="errorCount" class="errorBox">
        <div class="errorTitle">Hatalı işlemler</div>
        <div v-for="(e, i) in errorsList" :key="i" class="errRow">
          <div class="errHead">
            <span class="errKey">Satır</span>
            <span class="errVal">{{ (e && (e.index !== undefined && e.index !== null)) ? (Number(e.index) + 1) : (i + 1) }}</span>
          </div>
          <div v-if="e && e.stok_kod" class="errHead">
            <span class="errKey">Stok</span>
            <span class="errVal">{{ e.stok_kod }}</span>
          </div>
          <div class="errMsg">{{ (e && e.message) ? e.message : String(e) }}</div>
        </div>
      </div>

      <div class="actions">
        <button class="btn primary" @click="goSiparisList">Sipariş Listesi</button>
        <button class="btn" @click="goSepet">Sepet</button>
      </div>
    </div>

    <div v-else class="card fail">
      <div class="icon fail">!</div>
      <h2>Sipariş oluşturulamadı</h2>
      <p class="muted">{{ failText }}</p>

      <div v-if="errorCount" class="errorBox">
        <div class="errorTitle">Hatalı işlemler</div>
        <div v-for="(e, i) in errorsList" :key="i" class="errRow">
          <div class="errHead">
            <span class="errKey">Satır</span>
            <span class="errVal">{{ (e && (e.index !== undefined && e.index !== null)) ? (Number(e.index) + 1) : (i + 1) }}</span>
          </div>
          <div v-if="e && e.stok_kod" class="errHead">
            <span class="errKey">Stok</span>
            <span class="errVal">{{ e.stok_kod }}</span>
          </div>
          <div class="errMsg">{{ (e && e.message) ? e.message : String(e) }}</div>
        </div>
      </div>

      <div class="actions">
        <button class="btn primary" @click="goSepet">Sepete Dön</button>
        <button class="btn" @click="goSiparisList">Sipariş Listesi</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SiparisSonuc",
  data() {
    return {
      loading: true,
      result: null
    };
  },

  computed: {
    errorsList() {
      return (this.result && Array.isArray(this.result.errors)) ? this.result.errors : [];
    },
    errorCount() {
      return this.errorsList.length;
    },
    failCount() {
      if (this.result && typeof this.result.failCount === "number") return this.result.failCount;
      return this.errorCount;
    },
    satirCount() {
      const arr = this.result && Array.isArray(this.result.response) ? this.result.response : [];
      return arr.length;
    },
    seriSiraText() {
      const arr = this.result && Array.isArray(this.result.response) ? this.result.response : [];
      const first = arr.length ? arr[0] : null;
      if (!first) return "-";
      const seri = first.seri || "";
      const sira = first.sira || "";
      return (seri || sira) ? (String(seri) + " " + String(sira)).trim() : "-";
    },
    failText() {
      if (this.result && this.result.error) return this.result.error;
      return "İşlem sırasında hata oluştu.";
    }
  },

  created() {
    this.$store.setLoading([false, ""]);
    this.readResult();
  },

  methods: {
    readResult() {
      try {
        const raw = sessionStorage.getItem("siparis_result");
        this.result = raw ? JSON.parse(raw) : null;
      } catch (e) {
        this.result = null;
      } finally {
        this.loading = false;
      }
    },
    goSiparisList() {
      this.$router.push("/siparis/list");
    },
    goSepet() {
      this.$router.push("/cari/sepet");
    }
  }
};
</script>

<style scoped>
.page{
  min-height: 100vh;
  display:flex;
  align-items:center;
  justify-content:center;
  background:#f8fafc;
  padding:24px;
}
.card{
  width:100%;
  max-width:540px;
  border:1px solid #e5eaf1;
  background:#fff;
  border-radius:16px;
  padding:22px;
  box-shadow: 0 10px 24px rgba(15,23,42,.08);
  text-align:center;
}
.icon{
  width:72px; height:72px;
  border-radius:18px;
  margin:0 auto 10px;
  display:grid;
  place-items:center;
  font-weight:900;
  font-size:30px;
}
.icon.loading{
  background:#eff6ff;
  position:relative;
}
.icon.loading:after{
  content:'';
  width:24px; height:24px;
  border-radius:50%;
  border:3px solid rgba(37,99,235,.25);
  border-top-color:#2563eb;
  animation:spin 1s linear infinite;
}
.ok .icon{ background:#f0fdf4; color:#15803d; }
.fail .icon{ background:#fef2f2; color:#b91c1c; }
.muted{ color:#64748b; margin:8px 0 0; }
.rows{ margin-top:14px; text-align:left; }
.row{ display:flex; justify-content:space-between; padding:10px 0; border-bottom:1px solid #eef2f7; gap:12px; }
.row:last-child{ border-bottom:none; }
.k{ color:#64748b; font-weight:700; }
.v{ color:#0f172a; font-weight:800; }
.actions{ margin-top:16px; display:flex; justify-content:center; gap:10px; }\n.errorBox{ margin-top:14px; text-align:left; border:1px solid #fde68a; background:#fffbeb; border-radius:14px; padding:12px; }\n.errorTitle{ font-weight:900; color:#92400e; margin-bottom:8px; }\n.errRow{ background:#fff; border:1px solid #f1f5f9; border-radius:12px; padding:10px; margin-bottom:8px; }\n.errRow:last-child{ margin-bottom:0; }\n.errHead{ display:flex; justify-content:space-between; gap:10px; font-weight:800; }\n.errKey{ color:#64748b; }\n.errVal{ color:#0f172a; }\n.errMsg{ margin-top:6px; color:#7c2d12; font-weight:700; word-break:break-word; }\n
.btn{
  border:1px solid #dbe2ea;
  background:#fff;
  color:#0f172a;
  border-radius:12px;
  padding:10px 12px;
  font-weight:800;
  cursor:pointer;
}
.btn.primary{ background:#2563eb; border-color:#2563eb; color:#fff; }
@keyframes spin { to { transform: rotate(360deg); } }
</style>





// WEBPACK FOOTER //
// src/views/siparis/sonuc.vue